import React from "react";
import BasePartialRejectionDialog from "../SharedComponent/components/BasePartialRejectionDialog";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../config/redux/reducers";
import { fetchDeliveryReasons } from "./redux/expressSlice";
import { rejectionDataTransform } from "../mocks/SharedTransform/response.transforms";
import { createPayloadForReasons } from "../mocks/express/response.transforms";
import { bundleRejectionDataTransform } from "./../mocks/routePlanning/response.transforms";
import AppConstants from "../constants";

interface ExpUpdatePartialRejectionProps {
  open: boolean;
  consignment: any;
  items: any;
  closePopup: () => void;
  bundleProduct?: any;
  handleDialogAction?: (params: any) => void;
}

const ExpUpdatePartialRejection = (props: ExpUpdatePartialRejectionProps) => {
  const dispatch = useDispatch();
  const { rejectionReasonList, revisedAmountAfterCalculation } = useSelector(
    (state: AppState) => state.expressDashboard
  );
  const { countryCode } = useSelector((state: AppState) => state.common);
  const {
    open,
    consignment,
    items,
    closePopup,
    handleDialogAction,
    bundleProduct,
  } = props;

  // Fetch reasons for Express
  const fetchReasons = React.useCallback(
    (country: any) => {
      const payload = createPayloadForReasons(
        country,
        AppConstants.EXPRESS_CONSTANTS.DELIVERY_TYPE.LINE_ITEM_REJECTION
      );
      dispatch(fetchDeliveryReasons({ params: payload }));
    },
    [dispatch]
  );

  // Metadata selector for Express
  const metadataSelector = (consignment: any) => consignment?.metadata || {};

  return (
    <BasePartialRejectionDialog
      open={open}
      consignment={consignment}
      items={items}
      bundleProduct={bundleProduct}
      closePopup={closePopup}
      handleDialogAction={handleDialogAction}
      rejectionReasonList={rejectionReasonList}
      revisedAmountAfterCalculation={revisedAmountAfterCalculation}
      fetchRejectionReasons={fetchReasons}
      rejectionDataTransform={rejectionDataTransform}
      bundleRejectionDataTransform={bundleRejectionDataTransform}
      countryCode={countryCode}
      metadataSelector={metadataSelector}
    />
  );
};

export default ExpUpdatePartialRejection;
